module.exports = __webpack_public_path__ + "assets/css/fanoe.css";


//////////////////
// WEBPACK FOOTER
// ./assets/css/scss/fanoe.scss
// module id = 143
// module chunks = 0